<template>
  <div class="overall-bg p-0">
    <b-row class="tabviewtable">
      <b-col>
        <div class="form-white-bg" v-if="windowWidth > 545">
          <b-row>
            <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
              <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                  :ClearDateFilter="SearchValue" v-if="FilterLoading">
                  <template v-slot:filterslot>
                    <consumptionFilters @updatedcode="EmitCode" @updatedpatientid="Emitpatientid"
                      @updateduserid="EmitUserid" :removechiptype="removechipvalue" :itemsList="items" />
                  </template>
                </FilterForm>
              </b-collapse>
            </b-col>
            <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
              <SkeletonTableLoader :columns="headers" :loading="loading" />
              <div v-if="!loading">
                <MasterEmpty v-if="
                  items.length === 0 &&
                  !SearchValue.inputValue &&
                  !SearchValue.fromDate &&
                  !SearchValue.toDate
                " eheader="Consumption" econtent="Consumption" eimg="/src/assets/Img/icons/sub-tax.svg"
                  @createNew="IsCreate" />
                <Tableview v-if="
                  items.length !== 0 ||
                  SearchValue.inputValue ||
                  SearchValue.fromDate ||
                  SearchValue.toDate
                " :value="items" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true"
                  filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
                  @row-click="RowClick" :globalFilterFields="globalFilterFields" :filters="filters"
                  :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="false" :searchbox1="true"
                  @search="SearchBox" :exceldownload="true" :filterbtn="true" :showColumnFilters="false">
                  <template v-slot:exceldownload>
                    <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                      :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                  </template>
                  <template v-slot:filter>
                    <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                      :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                      @click="visible = !visible"></i>
                  </template>
                  <template v-slot:Add>
                    <span class="add">
                      <AddButton @click="IsCreate()" :btnname="$t('btn.plusaddnew')"></AddButton>
                    </span>
                    <!-- <span class="add">
                      <AddButton @click="IsReorder()" btnname="Reorder"></AddButton>
                    </span> -->
                  </template>
                  <template v-slot:status="{ data }">
                    <!-- {{ data.IsDraft}} -->
                    <RedStatus name="Draft" v-if="data.IsDraft == '1'" />
                    <GreenStatus name="Completed" v-if="data.IsDraft != '1'" />
                  </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)" />
                    </span>
                  </template>
                </Tableview>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div>
            <MasterEmpty v-if="
              items.length === 0 &&
              !SearchValue.inputValue &&
              !SearchValue.fromDate &&
              !SearchValue.toDate
            " eheader="Consumption" econtent="Consumption" eimg="/src/assets/Img/icons/sub-tax.svg"
              @createNew="IsCreate" />
            <MobileViewCardHeader :totalRecords="rowsCount" :state="state" @search="SearchBox" v-if="
              items.length !== 0 ||
              SearchValue.inputValue ||
              SearchValue.fromDate ||
              SearchValue.toDate
            ">
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in 5">
                  <div class="d-flex align-items-center justify-content-between">
                    <p class="light-name">{{ item["DocNo"] }}</p>
                    <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                  </div>
                  <p class="name">{{ item["PatientDetails"] }}</p>
                  <p class="name">{{ item["UserDetails"] }}</p>
                  <p class="light-name">
                    Consumption Name :
                    <span class="small-name">{{ item["DocDate"] }}</span>
                  </p>
                  <p class="light-name">
                    Items :
                    <span class="small-name">{{ item["ItemCount"] }}</span>
                  </p>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
  <!-- Commonly Used Components -->
  <Menu ref="menus" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete()" @no="Deletemodel = false" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
  <Toast />
  <!-- Commonly Used Components -->
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import Table from "../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../../Service/WithoutStockAffectService";
import Service from "../../../../Service/StockOutService";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import FilterForm from "../../../../../../components/FormComponents/FilterForm.vue";
import moment from "moment";
import requestFilters from "../../../../../../modules/Inventory/components/Filters/requestFilters.vue";
import consumptionFilters from "../../../../../../modules/Inventory/components/Filters/consumptionFilters.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    BacktoPage,
    Headerlayout,

    Table,
    Tableview,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    FilterForm,
    requestFilters,
    consumptionFilters,
    ExportOption,
    CrystalReportPrintPopUp,
  },
  props: {
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
  },
  setup(props) {
    const routes = useRoute();
    const router = useRouter();
    let StoreId = routes.query.Id ?? 0;
    let status = routes.query.status ?? 0;
    let Type = routes.query.Type;
    const items = ref([]);
    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    let loading1 = ref(false);
    let loading = ref(false);
    let StockTransId = 0;
    const datas = ref();
    const menus = ref();
    let visible = ref(false);

    let ExportList = ref([]);
    let PageName = ref("Consumption");
    let ExportOption = ref("");
    const CrystalReportPopup = ref(false);

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });

    watch(props, (newValue) => {
      debugger;
      let dataValue: any = {};
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        StoreId = dataValue.Id;
        status = dataValue.status;
        IsShow();
      }
    });

    const toast = useToast();
    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    const ParameterValues = ref({
      Id: 0,
      HospitalId: 0,
      BranchId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 72,
      HeaderTitle: "Consumption",
      ModuleId: 3,
    });

    watch(
      props,
      (newValue: any) => {
        debugger;
        console.log("props Changed", newValue.FunctionRights);
        Rights.value.Create = newValue.FunctionRights.Create;
        Rights.value.Update = newValue.FunctionRights.Update;
        Rights.value.Read = newValue.FunctionRights.Read;
        Rights.value.Delete = newValue.FunctionRights.Delete;
        Object.keys(ObjOperationId.value).forEach((key) => {
          if (newValue.FunctionRights[key])
            ObjOperationId.value[key] = newValue.FunctionRights[key];
        });
      },
      { deep: true }
    );

    const headers = [
      {
        header: t("storetabdetails.consumptiontableview.sno"),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      // {
      //   field: "Status",
      //   fieldDisplay: "false",
      //   header: t("storetabdetails.quotes.Status"),
      //   slot: "status",
      //   sortable: false,
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "mediumwidth",
      // },
      {
        header: t("storetabdetails.consumptiontableview.BranchName"),
        field: "BranchName",
        class: "filterdisplaynone smallwidth",
      },
      {
        header: t("storetabdetails.consumptiontableview.Code"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.consumptiontableview.Date"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.consumptiontableview.PatientName/PatientId"),
        field: "PatientDetails",
        bodyclass: "boldclass text_overflow2",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },

      {
        header: t("storetabdetails.consumptiontableview.UserName/UserId"),
        field: "UserDetails",
        bodyclass: "boldclass text_overflow2",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.consumptiontableview.ItemCount"),
        field: "ItemCount",
        bodyclass: "right_td",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.consumptiontableview.Value"),
        field: "Amount",
        // field: "TotalValue",
        bodyclass: "right_td",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.consumptiontableview.createdby"),
        field: "CreatedByName",
        bodyclass: "bluecolor",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.consumptiontableview.CreatedDate"),
        field: "CreatedAtHR",
        bodyclass: "bluecolor",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.consumptiontableview.Updatedby"),
        field: "ModifiedByName",
        bodyclass: "bluecolor",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.consumptiontableview.Updateddate"),
        field: "ModifiedAtHR",
        bodyclass: "bluecolor",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      DocDate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      UserId: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      length: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };
    const globalFilterFields = ref(headers.map((col) => col.field));
    function toggle(event, data) {
      debugger;
      console.log(event);

      datas.value = data;
      // Id.value = event.Id
      menus.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: true,
            command: async () => {
              // amendment();
              Editdata(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              // amendment();
              Deletedata(datas.value);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            //visible: Activevisible,
            command: async () => {
              Print(datas.value);
            },
          },
        ],
      },
    ]);
    const IsCreate = () => {
      let permissionResult: any = checkPermission(Rights, "Add");

      if (permissionResult.hasPermission) {
        router.push({
          name: "Consumption",
          query: {
            StoreId: StoreId,
            status: status,
            Type: Type,
            OperationId: ObjOperationId.value.CreateId,
            EntityId: ObjOperationId.value.EntityId,
            storebranchmapid: routes.query.storebranchmapid ?? 0,
            BranchId: Number(routes.query.BranchId ?? 0),
            IsDetail: 0,
            SiteId: Number(routes.query.SiteId ?? 0),
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };
    let StorebranchmapId = routes.query.storebranchmapid ?? 0;

    let ParamValues = ref({
      StockWoTransTMId: 0,
      StoreId: 0,
      DocNo: "",
      DocType: 5,
      status: 0,
      OperationId: ObjOperationId.value.CreateId,
      EntityId: ObjOperationId.value.EntityId,
      storebranchmapid: StorebranchmapId,
      //Type: "",
    });
    let QueryStringValue3: any = routes.query;
    ParamValues.value.StoreId = QueryStringValue3["Id"];
    ParamValues.value.status = QueryStringValue3["status"];
    const IsReorder = () => {
      // let permissionResult: any = checkPermission(Rights, "Add");

      // if (permissionResult.hasPermission) {
      (ParamValues.value.OperationId = ObjOperationId.value.CreateId),
        (ParamValues.value.EntityId = ObjOperationId.value.EntityId);
      router.push({
        name: "reOrderLevelBasedPO",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: "reOrder",
        },
        // query: {
        //   StoreId: StoreId,
        //   status: status,
        //   Type: Type,
        //   OperationId: ObjOperationId.value.CreateId,
        //   EntityId: ObjOperationId.value.EntityId,
        //   storebranchmapid: routes.query.storebranchmapid ?? 0
        // },
      });
      // } else {
      //   toast.add(permissionResult.toast);
      //   return;
      // }
    };
    function IsEdit() {
      // alert(data.StockTransId)

      router.push({
        path: "Consumption",
        query: {
          StockTransId: StockTransId,
          StoreId: StoreId,
          status: status,
          Type: Type,
          OperationId: ObjOperationId.value.UpdateId,
          EntityId: ObjOperationId.value.EntityId,
          storebranchmapid: Number(routes.query.storebranchmapid ?? 0),
          BranchId: Number(routes.query.BranchId ?? 0),
          IsDetail: 0,
        },
      });
    }

    const rowsCount = ref(0);
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }

      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    function SearchBox(value) {
      SearchValue.value.inputValue = value;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;

      IsShow();
    }
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "StoreId";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.Code ? "DocNo" : "";
        const columnValue1 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName2 = filterItems.value.PatientId ? "PatientCode" : "";
        const columnValue2 = filterItems.value.PatientId
          ? filterItems.value.PatientId
          : "";
        const columnName3 = filterItems.value.Userid ? "UserCode" : "";
        const columnValue3 = filterItems.value.Userid
          ? filterItems.value.Userid
          : "";
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await Service.listStockOutMasterTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          14,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          columnName3,
          columnValue3,
          "",
          "",
          Flag,
          searchOption,
          Condition
        );

        response["result"] = response["result"].map((item) => {
          item.PatientDetails =
            (item.PatientName ? item.PatientName : "-") +
            " / " +
            (item.PatientCode ? item.PatientCode : "-");
          item.PatientDetails =
            item.PatientDetails == "- / -" ? "" : item.PatientDetails;
          item.UserDetails =
            (item.UserName ? item.UserName : "-") +
            " / " +
            (item.UserCode ? item.UserCode : "-");
          item.UserDetails =
            item.UserDetails == "- / -" ? "" : item.UserDetails;
          return item;
        });

        items.value = response["result"];

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const pageNum = state.currentPage;
        const pageSize = 0;
        const columnName = "StoreId";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.Code ? "DocNo" : "";
        const columnValue1 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName2 = filterItems.value.PatientId ? "PatientCode" : "";
        const columnValue2 = filterItems.value.PatientId
          ? filterItems.value.PatientId
          : "";
        const columnName3 = filterItems.value.Userid ? "UserCode" : "";
        const columnValue3 = filterItems.value.Userid
          ? filterItems.value.Userid
          : "";
        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.BranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await Service.listStockOutMasterTM(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          14,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          columnName3,
          columnValue3,
          "",
          "",
          Flag,
          searchOption,
          Condition
        );

        response["result"] = response["result"].map((item) => {
          item.PatientDetails =
            (item.PatientName ? item.PatientName : "-") +
            " / " +
            (item.PatientCode ? item.PatientCode : "-");
          item.PatientDetails =
            item.PatientDetails == "- / -" ? "" : item.PatientDetails;
          item.UserDetails =
            (item.UserName ? item.UserName : "-") +
            " / " +
            (item.UserCode ? item.UserCode : "-");
          item.UserDetails =
            item.UserDetails == "- / -" ? "" : item.UserDetails;
          return item;
        });

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    const IsDelete = async () => {
      try {
        const response = await Service.DeleteStockOutTM(StockTransId);
        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          IsShow();
          Deletemodel.value = false;
          deletepop.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    };

    function Editdata(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Edit");

      if (permissionResult.hasPermission) {
        StockTransId = data.StockOutTransId;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    function Deletedata(data) {
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        StockTransId = data.StockOutTransId;
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    let filterItems = ref({
      Date: "",
      Userid: "",
      PatientId: "",
      Code: "",
    });

    let emitedfilterItems = ref({
      Userid: "",
      PatientId: "",
      Code: "",
    });
    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    const removechipvalue = ref(0);

    const EmitCode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    const Emitpatientid = (data) => {
      emitedfilterItems.value.PatientId = data;
    };

    const EmitUserid = (data) => {
      emitedfilterItems.value.Userid = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      filterItems.value.Userid = emitedfilterItems.value.Userid;
      filterItems.value.PatientId = emitedfilterItems.value.PatientId;
      filterItems.value.Code = emitedfilterItems.value.Code;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 4;
      filterItems.value.PatientId = "";
      filterItems.value.Code = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      IsShow();
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      } else if (data == "PatientId") {
        filterItems.value.PatientId = "";
        removechipvalue.value = 2;
      } else if (data == "Userid") {
        filterItems.value.Userid = "";
        removechipvalue.value = 3;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };
    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;

      router.push({
        path: "Consumption",
        query: {
          StockTransId: event.data.Id,
          StoreId: StoreId,
          status: status,
          Type: Type,
          OperationId: ObjOperationId.value.UpdateId,
          EntityId: ObjOperationId.value.EntityId,
          storebranchmapid: Number(routes.query.storebranchmapid ?? 0),
          BranchId: Number(routes.query.BranchId ?? 0),
          IsDetail: 1,
        },
      });
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.StockOutTransId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
      ParameterValues.value.BranchId = ObjData.BranchId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    return {
      CrystalReportPopup,
      IsReorder,
      Editdata,
      Deletedata,
      Deletemodel,
      deletepop,
      Editmodel,
      headers,
      items,
      IsShow,
      IsDelete,
      globalFilterFields,
      filters,
      IsCreate,
      IsEdit,
      loading1,
      rowsCount,
      state,
      loading,
      itemListed,
      menus,
      toggle,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      EmitCode,
      Emitpatientid,
      EmitUserid,
      removeChip,
      removechipvalue,
      SearchBox,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      ShowRows,
      windowWidth,
      visible,
      RowClick,
      ParameterValues,
      PrintType,
      hidepopup,
    };
  },
});
</script>
